module.exports = "<div class=\"header-bar\">\n  <div class=\"header-bar__title\">Ryanair Connections</div>\n</div>\n"